import { useEffect } from 'react';

const Callback = () => {
  useEffect(() => {
    const { ApperUI } = window.ApperSDK;
    ApperUI.showSSOVerify("#authentication-callback");
  }, []);

  return (
    <div id="authentication-callback"></div>
  );
};

export default Callback;